export const CLIENT_LIST_REQUEST    = 'CLIENT_LIST_REQUEST';
export const CLIENT_LIST_SUCCESS    = 'CLIENT_LIST_SUCCESS';
export const CLIENT_LIST_FAIL       = 'CLIENT_LIST_FAIL';